// Lightweight product-ID obfuscation for navigation state.
// Real IDs are never sent as plain numbers through router state;
// API calls still use the decoded numeric ID internally.

const SALT = "s9xkv2pdQ";

/**
 * Encode a numeric product ID to an opaque string.
 * e.g. 42 → "NDI6czl4a3YycGRR"
 */
export const encodeId = (id) => {
  if (id === null || id === undefined || id === "") return "";
  try {
    return btoa(String(id) + ":" + SALT).replace(/=+$/, "");
  } catch {
    return String(id);
  }
};

/**
 * Decode an encoded ID back to a number.
 * Returns null if the value is invalid or tampered.
 */
export const decodeId = (encoded) => {
  if (!encoded) return null;
  try {
    // Restore stripped base64 padding
    const pad = (4 - (encoded.length % 4)) % 4;
    const plain = atob(encoded + "=".repeat(pad));
    const parts = plain.split(":");
    if (parts.length < 2 || parts[1] !== SALT) return null;
    const id = parseInt(parts[0], 10);
    return isNaN(id) ? null : id;
  } catch {
    return null;
  }
};
